<template>
  <t-layout :showNav="false">
    <div class="notice">公告结果来源于中国福利彩票官网，具体可在官网查询~</div>
    <div class="list-page">
      <!-- <div class="tabs">
        <div
          class="tab"
          :class="selected == 1 ? 'tab-3d' : ''"
          v-for="(item, index) in tabs"
          :key="index"
          @click="switchTab(index)"
        >
          <span :class="selected == index ? 'selected' : ''">{{ item.tab }}</span>
        </div>
      </div> -->

      <div v-if="list.length" class="container">
        <div v-for="(item, index) in list" :key="index" class="coupon-wrap">
          <div class="coupon">
            <div class="title">
              <span>第{{ item.issue }}期</span>{{ item.data }}
            </div>
            <div class="code" :class="item.lottery == 1 ? 'code-2' : ''">
              <div v-for="(code, idx) in item.stakes" :key="idx" class="num">
                {{ code }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="no-coupon">暂无数据~</div>

      <tabbar :current="2"></tabbar>
    </div>
  </t-layout>
</template>

<script>
import tabbar from '../components/tabbar/index'

export default {
  name: 'noticeLotteryView',
  components: {
    tabbar
  },
  data() {
    return {
      loading: false,

      tabs: [
        { status: 1, tab: '双色球' },
        { status: 2, tab: '福彩3D' }
      ],
      selected: 0,
      list: []
    }
  },
  created() {
    const options = this.$route.query
    if (options.token) {
      let token = decodeURIComponent(options.token)
      localStorage.setItem('token', token)
    }
  },
  activated() {
    window.scrollTo(0, 0)
    this.$store.commit('setTitle', '开奖公告')
    this.getUserShopCoupon()
  },
  methods: {
    getUserShopCoupon() {
      let status = this.tabs[this.selected].status
      this.$api.coupon.getLotteryAnnouncement({ lottery_id: status }).then(res => {
        const data = res.data
        console.log('data', data)

        if (data.code == 0) {
          this.list = data.data
        }
      })
    },

    switchTab(i) {
      window.scrollTo(0, 0)
      this.selected = i
      this.getUserShopCoupon()
    },

    async toCouponDetail(item) {
      let result = await this.$api.user.getUserInfo()
      let data = result.data
      if (data.code == 0) {
        let userInfo = data.data.user_info
        if (userInfo.mobile) {
          this.$router.push({
            path: `/lottery/detail?from=user&id=${item.id}&user_coupon_id=${item.user_coupon_id}`
          })
        } else {
          this.$eventBus.$emit('haddleLogin')
        }
      }
    },

    haddleSuccess() {
      this.getUserShopCoupon()
    }
  }
}
</script>

<style lang="less" scoped>
.notice {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9;
  width: 100%;
  height: 64rpx;
  background-color: #fff1f4;
  color: #ff5566;
  font-size: 26rpx;
  line-height: 64rpx;
  padding-left: 68rpx;
  background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/notice-icon.png');
  background-position: 24rpx center;
  background-repeat: no-repeat;
  background-size: 32rpx 32rpx;
}

.list-page {
  padding-top: 64rpx;
  // padding-top: 96rpx;
  padding-bottom: 168rpx;
}

.tabs {
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  background-color: #fff;
  font-size: 30rpx;
  z-index: 9;
  padding: 0 100rpx;

  .tab {
    text-align: center;
    width: 50%;

    span {
      display: block;
      height: 96rpx;
      line-height: 96rpx;
      color: #808991;
      position: relative;
      letter-spacing: 2rpx;
    }

    span.selected {
      font-weight: 600;
      color: #ff5667;
      position: relative;

      &::before {
        content: '';
        display: block;
        width: 48rpx;
        height: 48rpx;
        background: url(https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/notice-icon-2-v2.png)
          no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        z-index: -1;
        top: 6rpx;
        left: 50%;
        transform: translateX(-50%);
      }

      &::after {
        content: '';
        height: 4rpx;
        width: 48rpx;
        border-radius: 4rpx;
        background: #ff5667;
        position: absolute;
        bottom: 6rpx;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    &.tab-3d {
      span.selected {
        color: #1694e7;

        &::before {
          background: url(https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/notice-icon-1-v2.png)
            no-repeat top center;
          background-size: 100% 100%;
        }

        &::after {
          background: #1694e7;
        }
      }
    }
  }
}

.container {
  padding: 20rpx;
}

.no-coupon {
  width: 514rpx;
  height: 350rpx;
  margin-top: 400rpx;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  font-size: 30rpx;
  color: #9b9b9b;
  background: url(https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/img-blank.png) no-repeat
    top center;
  background-size: 100% 298rpx;
}

.coupon {
  width: 100%;
  background: #fff;
  padding: 40rpx 24rpx;
  margin-bottom: 20rpx;
  overflow: hidden;

  .title {
    color: #a1a7ad;
    font-size: 26rpx;
    line-height: 30rpx;
    margin-bottom: 32rpx;

    span {
      color: #353738;
      font-size: 30rpx;
      margin-right: 8rpx;
      font-weight: 500;
    }
  }

  .code {
    display: flex;

    .num {
      display: block;
      width: 60rpx;
      height: 60rpx;
      border-radius: 30rpx;
      margin-right: 16rpx;
      background: linear-gradient(325deg, #f93434 20.42%, #ff7759 88.58%);
      color: #fff;
      font-size: 30rpx;
      line-height: 60rpx;
      text-align: center;
      font-weight: 500;
    }

    &.code-2 {
      .num:last-child {
        background: linear-gradient(325deg, #027bdb 20.42%, #3dc5ff 88.58%);
      }
    }
  }
}
</style>
